import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const BelastungsEKGPage = () => {
  return (
    <Layout>
      <PageHero
        title="Belastungs-EKG: Ihr Herz-Kreislauf-Check unter Druck"
        subtitle="Wir überprüfen die Leistungsfähigkeit Ihres Herzens unter körperlicher Anstrengung."
        backgroundImage="/images/belastungs_EKG.webp"
        ctaText="Belastungs-EKG buchen"
      />

      <ContentSection
        title="Die wahre Leistungsfähigkeit Ihres Herzens"
        content="Das Belastungs-EKG (Ergometrie) ist eine wichtige Untersuchung, um die Reaktion Ihres Herz-Kreislauf-Systems auf körperliche Belastung zu beurteilen. Unter ärztlicher Aufsicht treten Sie auf einem Fahrradergometer, während wir kontinuierlich Ihre Herzaktivität, Ihren Blutdruck und Ihren Puls überwachen. So können wir Engpässe oder Unregelmäßigkeiten aufdecken."
        image="/images/belastungs_EKG.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Herz-Kreislauf-Leistungstest in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet das Belastungs-EKG an, um die funktionelle Kapazität Ihres Herzens und Kreislaufs unter Belastung zu bewerten."
      />

      <CTASection
        title="Möchten Sie Ihre Herz-Kreislauf-Leistung testen lassen?"
        subtitle="Vereinbaren Sie einen Termin für das Belastungs-EKG."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default BelastungsEKGPage;
